class ArrowKeysNavigation {
    constructor(elementId, containerSelector) {
        this.focusableItems = [];
        this.containerSelector = containerSelector;
        this.elementId = elementId;
        this.currentFocusedIndex = -1;
    }

    /** a11y: create list of focusable items. This could change during component life cycle, so this method should be called again in componentDidUpdate. */
    determineFocusable(containerSelector) {
        const element = document.getElementById(this.elementId);
        const focusableNodesSelector = 'a[href], area[href], input, select, textarea, button:not([disabled]), [tabindex="0"]';

        if (!element) {
            return;
        }

        if (!containerSelector) {
            this.focusableItems = element.querySelectorAll(focusableNodesSelector);
            return;
        }

        const contentContainer = element.querySelector(containerSelector);
        if (contentContainer) {
            this.focusableItems = contentContainer.querySelectorAll(focusableNodesSelector);
        }
    }

    bindEvents() {
        this.determineFocusable(this.containerSelector);

        if (this.focusableItems.length && typeof document !== 'undefined') {
            document.addEventListener('keydown', this.handleArrowKeys);
        }
    }

    unbindEvents() {
        if (typeof document !== 'undefined') {
            document.removeEventListener('keydown', this.handleArrowKeys);
        }
        this.currentFocusedIndex = -1;
    }

    setFocusTo(index) {
        if (!this.focusableItems.length) {
            return;
        }
        if (!this.focusableItems[index]) {
            return;
        }
        this.focusableItems[index].focus();
    }

    getFocusIndex(newIndex) {
        if (newIndex > this.focusableItems.length - 1) {
            return 0;
        }
        if (newIndex < 0) {
            return this.focusableItems.length - 1;
        }
        return newIndex;
    }

    handleArrowKeys = (e) => {
        const keys = {
            DOWN: 40,
            RIGHT: 39,
            UP: 38,
            LEFT: 37
        };

        if (e.keyCode === keys.DOWN || e.keyCode === keys.RIGHT) {
            e.preventDefault();
            this.currentFocusedIndex = this.getFocusIndex(this.currentFocusedIndex + 1);
            this.setFocusTo(this.currentFocusedIndex);
            return true;
        }

        if (e.keyCode === keys.UP || e.keyCode === keys.LEFT) {
            e.preventDefault();
            this.currentFocusedIndex = this.getFocusIndex(this.currentFocusedIndex - 1);
            this.setFocusTo(this.currentFocusedIndex);
            return true;
        }

        return false;
    }
}

export default ArrowKeysNavigation;